<template>
  <mdb-container fluid>
    <Header></Header>
    <Admintopbar />
    <section class="mt-3">
    <mdb-row class="pt-4 justify-content-around">
      <mdb-col md='12'>
        <mdb-spinner v-if="!checklist" />
        <checklist-creation-form v-else @save="reloadChecklist" :initial-checklist="checklist" />
      </mdb-col>
    </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
import {
  mdbContainer, mdbSpinner, mdbCol, mdbRow,
} from 'mdbvue';
import ChecklistCreationForm from '@/components/ChecklistCreationForm.vue';
import Apicall from '@/libs/Apicall';
import Admintopbar from '@/components/Admintopbar.vue';
import Header from '@/components/Header.vue';

export default {
  breadcrumb: {

  },
  components: {
    Admintopbar,
    Header,
    ChecklistCreationForm,
    mdbCol,
    mdbRow,
    mdbContainer,
    mdbSpinner,
  },
  name: 'EditChecklist',
  data() {
    return {
      title: 'Vue 2 Component',
      message: 'This is a basic Vue 2 component',
      checklist: null,
    };
  },
  mounted() {
    this.getChecklist(this.$route.params.checklistId);
  },
  methods: {
    getChecklist(id) {
      const api = new Apicall();

      api.call('POST', 'api/adminchecklist/get-one', {
        checklistId: id,
      }).then((response) => {
        if (response.status === 'OK') {
          this.checklist = response.data;
        } else {
          console.log(response.msg);
        }
      });
    },
    reloadChecklist() {
      this.checklist = null;
      this.getChecklist(this.$route.params.checklistId);
    },
  },
};
</script>
